import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import { shadeHexColor } from '@/utils';

import { useBreakpoints } from '@/hooks';

import { OperatingPhase, setOperatingPhase, store } from './store';

function OperatingPhaseSwitch() {
  const snap = useSnapshot(store);
  const { t } = useTranslation();
  const { useDown } = useBreakpoints();
  const downMd = useDown('md');

  const handleChange = (operatingPhase: OperatingPhase) => () => {
    setOperatingPhase(operatingPhase);
  };

  return (
    <ButtonGroup size="small" sx={{ flexGrow: downMd ? 1 : 0 }}>
      {Object.entries(OperatingPhase).map(([key, value]: [string, string]) => (
        <Button
          color="primary"
          key={key}
          onClick={handleChange(value as OperatingPhase)}
          sx={{
            backgroundColor: (theme) =>
              snap.operatingPhase === value
                ? shadeHexColor(theme.palette.primary.main, 0.8)
                : 'unset',
            '&:hover': {
              backgroundColor: (theme) =>
                snap.operatingPhase === value
                  ? shadeHexColor(theme.palette.primary.main, 0.8)
                  : shadeHexColor(theme.palette.primary.main, 0.9),
            },
          }}
        >
          {t(`operatingPhase.${value}`)}
        </Button>
      ))}
    </ButtonGroup>
  );
  //   <ToggleButtonGroup
  //     color="primary"
  //     value={snap.operatingPhase}
  //     exclusive
  //     onChange={handleChange}
  //     aria-label="Platform"
  //   >
  //     {Object.entries(OperatingPhase).map(([key, value]: [string, string]) => (
  //       <ToggleButton key={key} value={value}>
  //         {value}
  //       </ToggleButton>
  //     ))}
  //   </ToggleButtonGroup>
  // );
}

export { OperatingPhaseSwitch };
